import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LanguageIcon from '@mui/icons-material/Language';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';

const drawerWidth = 240;

function NavBar({ setLanguage ,language }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isRTL = language === 'ar' || language === 'ku';


    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handleNavigation = (path) => {
        navigate(path);
        handleDrawerToggle();
    };

    const handleLanguageMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLanguageMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        handleLanguageMenuClose();
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Divider />
            <List>
                {t('navItems', { returnObjects: true }).map(({ name, path }) => (
                    <ListItem key={name} disablePadding>
                        <ListItemButton
                            onClick={() => handleNavigation(path)}
                            sx={{ textAlign: 'center', "&:hover": { backgroundColor: '#6A9C89' } }}
                        >
                            <ListItemText primary={name} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    const container = typeof window !== 'undefined' ? () => window.document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav" sx={{ backgroundColor: '#fdfdfd', boxShadow: 'none' }}>
            <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' }, color: 'black' }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: { xs: 'space-between', md: 'space-around' }, alignItems: 'center' }}>
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{ color: '#16423c', fontSize: { xs: 15, md: 'auto' }, fontFamily: "'Varela Round', sans-serif" }}
                        >
                            Waisi Consulting
                        </Typography>
                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                            {t('navItems', { returnObjects: true }).map(({ name, path }) => (
                                <Button
                                    key={name}
                                    onClick={() => handleNavigation(path)}
                                    sx={{ color: 'black', fontFamily: "'Varela Round', sans-serif", "&:hover": { backgroundColor: '#6A9C89' } }}
                                >
                                    {name}
                                </Button>
                            ))}
                        </Box>
                        <Box>
                            <Button variant="contained" sx={{
                                ml: 1, backgroundColor: '#16423ccc', color: 'white', fontFamily: "'Varela Round', sans-serif",
                                '&:hover': { backgroundColor: '#13413a' }
                            }} onClick={() => handleNavigation('/contact')}>
                                {t('contact')}
                            </Button>
                        </Box>
                        <Box>
                            <IconButton onClick={handleLanguageMenuOpen} sx={{ ml: 2, color: 'black' }}>
                                <LanguageIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleLanguageMenuClose}
                            >
                                <MenuItem onClick={() => handleLanguageChange('en')}>English</MenuItem>
                                <MenuItem onClick={() => handleLanguageChange('ar')}>عربي</MenuItem>
                                <MenuItem onClick={() => handleLanguageChange('ku')}>کوردی</MenuItem>
                            </Menu>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
        </Box>
    );
}

NavBar.propTypes = {
    setLanguage: PropTypes.func.isRequired,
};

export default NavBar;
